(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195,5664],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fblog%2Findex.tsx&page=%2Fblog!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__("./src/pages/blog/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Blog/BlogPost.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ BlogPost; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/Image/Image.tsx");
/* harmony import */ var _components_Elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/components/Elements/index.ts");
/* harmony import */ var _hooks_useENSData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/hooks/useENSData.ts");
/* harmony import */ var _data_Constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/data/Constants.ts");
/* harmony import */ var _Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");








const BlogPost = (props)=>{
    const { post , ...rest } = props;
    const [, displayName] = (0,_hooks_useENSData__WEBPACK_IMPORTED_MODULE_4__/* .useENSData */ .L)(post.contributor);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .LinkBox */ .fG, {
        display: "flex",
        flexDir: "column",
        rounded: "lg",
        shadow: "xl",
        bg: "white",
        _dark: {
            bg: "gray.700"
        },
        overflowX: "hidden",
        ...rest,
        children: [
            post.cover_image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, {
                h: "52",
                src: post.cover_image,
                loading: "lazy",
                alt: post.title,
                width: "full",
                imgH: _data_Constants__WEBPACK_IMPORTED_MODULE_7__/* .IMAGE_BOX_SIZE */ .xh,
                imgW: _data_Constants__WEBPACK_IMPORTED_MODULE_7__/* .IMAGE_BOX_SIZE */ .xh * _data_Constants__WEBPACK_IMPORTED_MODULE_7__/* .WIKI_IMAGE_ASPECT_RATIO */ .ag
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                h: "fit-content",
                p: "4",
                flexDir: "column",
                flex: "auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                        flex: "auto",
                        align: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            href: "/blog/".concat(post.digest),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                                fontSize: "lg",
                                fontWeight: "bold",
                                noOfLines: 3,
                                children: post.title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                        mt: 3,
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                                justifyContent: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements__WEBPACK_IMPORTED_MODULE_3__/* .Avatar */ .qE, {
                                        address: post.contributor,
                                        size: 20,
                                        alt: "unknown"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                                        color: "brand.500",
                                        fontWeight: "bold",
                                        fontSize: "sm",
                                        marginLeft: 2,
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                                fontSize: "sm",
                                color: "gray.400",
                                _dark: {
                                    color: "whiteAlpha.400"
                                },
                                children: new Date((post.timestamp || 0) * 1000).toDateString()
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ "./src/pages/blog/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Blog": function() { return /* binding */ blog_Blog; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/image/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./src/components/Blog/BlogPost.tsx
var BlogPost = __webpack_require__("./src/components/Blog/BlogPost.tsx");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
;// CONCATENATED MODULE: ./src/components/SEO/Blog.tsx



const BlogHeader = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: "Blog",
        description: "Stay up to date with latest stories and gist brought to you by IQ.Wiki",
        canonical: "https://iq.wiki/blog",
        openGraph: {
            title: "Blog",
            description: "Stay up to date with latest stories and gist brought to you by IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWIKI",
            site: "IQWiki"
        }
    });
/* harmony default export */ var Blog = (BlogHeader);

;// CONCATENATED MODULE: ./src/pages/blog/index.tsx





var __N_SSG = true;
const blog_Blog = (param)=>{
    let { blogEntries  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* chakra.div */.m$.div, {
                bgColor: "pageBg",
                my: -8,
                py: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* chakra.div */.m$.div, {
                    w: "min(90%, 1100px)",
                    mx: "auto",
                    my: {
                        base: "10",
                        lg: "16"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                            wrap: "wrap",
                            justifyContent: [
                                "center",
                                "space-between"
                            ],
                            my: 4,
                            minWidth: 100,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                    as: "h1",
                                    size: "2xl",
                                    letterSpacing: "wide",
                                    children: "IQ.Wiki Blog"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                    alignItems: "center",
                                    mt: [
                                        5,
                                        0
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                            mr: 5,
                                            children: "More from us"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                                            href: "https://mirror.xyz/0x3c1ccc207b3796D907B0024eD79fa2A11Af8D912",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                                src: "/images/logos/kr.svg",
                                                width: 10
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                                            href: "https://mirror.xyz/0xcd5Cc4F54C20C80aED2db81CBaf82153Fb95C1b1",
                                            target: "_blank",
                                            ml: 5,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                                src: "/images/logos/cn.svg",
                                                width: 10
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* SimpleGrid */.MI, {
                            mt: {
                                base: "15",
                                md: "16"
                            },
                            columns: {
                                base: 1,
                                md: 2,
                                lg: 3
                            },
                            spacingX: "5",
                            spacingY: "14",
                            children: blogEntries && blogEntries.length > 0 ? blogEntries.map((b, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPost/* BlogPost */.J, {
                                    post: b
                                }, i)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                                colSpan: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                    fontSize: "md",
                                    textAlign: "center",
                                    children: "No entries so far..."
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var blog = (blog_Blog);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,2192,7249,8764,5619,4095,8283,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fblog%2Findex.tsx&page=%2Fblog!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);